import React, { useEffect, useState } from 'react';
import { GraphvizDiagramCard } from './GraphvizDiagramCard';
import { C4DiagramModel } from './types';

export interface C4DiagramCardProps {
  model: C4DiagramModel;
}

export const C4DiagramCard = (props: C4DiagramCardProps) => {
  const [model, setModel] = useState(props.model);

  useEffect(() => {
    setModel(props.model);
  }, [props.model]);

  return <GraphvizDiagramCard model={model} edit={false} />;
};
